import type { GetClientPersonOutput } from '@/entities/client';

// A saved primary address can exist with every part empty (clients saved through edit profile).
export function hasAddressContent(address: GetClientPersonOutput['address']): boolean {
    if (!address) return false;

    return [address.street1, address.street2, address.city, address.state, address.zip].some(
        (part) => part?.trim(),
    );
}
